exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Paragraph{margin:20px 0;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;color:#393939}.Paragraph p{font-size:18px;line-height:28px}@media (max-height:600px),(max-width:649px){.Paragraph,.Paragraph p{font-size:16px}.Paragraph p{line-height:24px}}.Paragraph__header{margin-top:40px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;flex-direction:column}.Paragraph h3{font-size:16px;text-transform:uppercase;font-family:Roboto,sans-serif}.Paragraph__inner{max-width:700px;margin:0 auto}@media (max-width:740px){.Paragraph__inner{margin-left:20px;margin-right:20px}}.Paragraph__vertical-spacer{width:1px;height:40px;background-color:#00ff40;margin:10px 0;margin-top:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/components/DetailPage/Paragraph/Paragraph.scss
// module id = 286
// module chunks = 0